import { ChevronRight, MoveRightIcon } from "lucide-react";
import React from "react";
import { NavLink } from "react-router-dom";

const SellingInfo = () => {
  return (
    <div className="flex flex-col items-start justify-start mx-[2.52222vw] w-[40%] py-5">
      <div className="flex flex-row">
        <NavLink
          to="sellAs"
          className="border-2 border-purple-700 rounded-md px-3 py-2 text-[2.23755vh] font-medium font-outfit text-[#5652B0] flex items-center justify-center flex-row">
          {" "}
          <span className="px-2">Sell as</span>
          <ChevronRight />
        </NavLink>
        <input
          type="text"
          placeholder="Note: 6 Packed added"
          className="bg-[#EEF3F8] px-[8px] rounded-md mx-5"
        />
      </div>

      <div className="flex flex-row mt-9 items-start justify-center gap-x-3 pb-12">
        <button className="border-2 border-purple-700 rounded-md px-9 py-2 text-[16px] font-medium font-outfit text-[#CAC4D0] flex items-center justify-center flex-row">
          {" "}
          <span className="px- text-[#5652B0] px-3">Cancel</span>
        </button>
        <button className="border-2 border-purple-700 rounded-md px-9 py-2 text-[16px] font-medium font-outfit flex items-center justify-center flex-row bg-[#5652B0]">
          {" "}
          <span className="px-2 text-white ">Save Product</span>
        </button>
      </div>
    </div>
  );
};

export default SellingInfo;
